import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PrecisionLogoMain } from "assets/website";
import {
  getLumaEventId,
  useLumaCheckoutScript,
} from "features/landing/events/lumaCheckout";

interface EventNavbarProps {
  lumaUrl: string;
}

const EventNavbar: React.FC<EventNavbarProps> = ({ lumaUrl }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  useLumaCheckoutScript();
  const lumaEventId = getLumaEventId(lumaUrl);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <header
      className={`pt-8 fixed w-screen top-0 z-[99] bg-transparent flex justify-center transition-transform duration-300 ease-in-out ${
        isVisible ? "" : "-translate-y-full"
      }`}
    >
      <section className="w-full h-full flex flex-col">
        <section className="flex items-center justify-between rounded-[16px] px-6 lg:h-auto h-[70px] bg-[#050B17] w-[90%] mx-auto">
          <Link className="h-auto -mb-1" to="/">
            <PrecisionLogoMain className="md:w-[162px] sm:w-[140px] w-[110px] sm:mb-0 mb-1" />
          </Link>
          <a
            href={lumaUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-luma-action="checkout"
            data-luma-event-id={lumaEventId}
            className="sm:py-2.5 py-2 sm:px-6 px-3 my-5 rounded-md sm:text-sm text-xs text-[#012169] bg-white sm:font-medium"
          >
            Reserve my Seat
          </a>
        </section>
      </section>
    </header>
  );
};

export { EventNavbar };
